import { render, staticRenderFns } from "./addDataButton.vue?vue&type=template&id=051501b8&scoped=true&"
var script = {}
import style0 from "./addDataButton.vue?vue&type=style&index=0&id=051501b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051501b8",
  null
  
)

export default component.exports